module.exports = __webpack_public_path__ + "static/media/FrontendIcon.89b3477e.svg";